<template>
  <div class="bg-FF">
    <div class=" b-r-10 m-10">
      <van-form @submit="onSubmit" :show-error="false" error-message-align="right">
        <van-field input-align="right" label="记录人" :value="loginUser.nickName" readonly/>
        <van-field input-align="right" label="所属部门" autosize type="textarea" :value="this.loginUser.deptNames[0]"
                   readonly/>
        <van-field input-align="right" :value="visitFormData.customerCompanyName" label="所属客户"
                   :rules="[{ required: true, message: '请选择所属客户' }]" placeholder="请选择所属客户">
          <template #input>
            <view-item @click.native="isShowPopup(companyName,'companyName')" :value="visitFormData.customerCompanyName"
                       placeholder="请选择所属客户"/>
            <van-popup v-model="companyName.show" position="bottom">
              <van-nav-bar title="所属客户" left-text="取消" right-text="确定" @click-left="companyName.show = false"
                           @click-right="sskhConfirm"/>
              <van-search v-model="companyName.filterText" @search="pickerSearchCompany" show-action clearable
                          shape="round">
                <template #action>
                  <div @click="pickerSearchCompany">搜索</div>
                </template>
              </van-search>
              <van-picker ref="companyName" value-key="companyName" :columns="companyName.filteredData"
                          @cancel="companyName.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <!-- 客户地址 -->
        <van-field input-align="right" :readonly="isEdit" v-model="visitFormData.customerCompanyPlace" rows="2" autosize
                   label="客户地址" type="textarea" maxlength="140" placeholder="请输入客户地址" show-word-limit>
        </van-field>
        <!-- 当前位置定位 -->
        <!--        <van-field readonly clickable name="picker" rows="2" type="textarea" autosize :value="visitFormData.nowLocation"-->
        <!--                   input-align="right" label="当前位置" placeholder="点击获取当前位置" @click="getLocal()"/>-->
        <van-popup v-model="showLocationPicker" position="bottom">
          <van-picker show-toolbar :columns="locationColumns" @confirm="onLocationConfirm"
                      @cancel="showLocationPicker = false"/>
        </van-popup>
        <!-- 拜访日期 -->
        <van-field input-align="right" clickable required :rules="[{ required: true, message: '请选择拜访日期' }]"
                   :value="visitFormData.visitTime" readonly label="拜访日期" placeholder="点击拜访日期"
                   @click="dateTimeShow = true"/>
        <van-popup v-model="dateTimeShow" position="bottom">
          <van-datetime-picker v-model="visitFormData.visitDateTime" type="datetime" title="选择完整时间"
                               @cancel="dateTimeShow = false"
                               @confirm="dateTimeConfirm"/>
        </van-popup>
        <!-- 拜访方式 -->
        <van-field input-align="right" readonly clickable required name="dictLabel" :value="visitFormData.visitTypeName"
                   label="拜访方式" placeholder="请选择拜访方式" @click="pickerShow = true"
                   :rules="[{ required: true, message: '请选择拜访方式' }]"/>
        <van-popup v-model="pickerShow" position="bottom">
          <van-picker show-toolbar :columns="visitDictData" @confirm="pickerConfirm" @cancel="pickerShow = false"
                      value-key="dictLabel"/>
        </van-popup>

        <!-- 拜访人 -->
        <van-field input-align="right" readonly clickable required name="picker" :value="visitFormData.customerUserName"
                   label="拜访人" placeholder="请选择拜访人" @click="getCustomerUser(companyId)"
                   :rules="[{ required: true, message: '请选择拜访人' }]"/>
        <van-popup v-model="userShow" position="bottom">
          <van-picker show-toolbar :columns="customerUserList" @confirm="userConfirm" @cancel="userShow = false"
                      :show="userShow" value-key="userName"/>
        </van-popup>

        <!--拜访时长-->
        <van-field input-align="right" v-if="visitFormData.visitType == '0'" @change="buildVisitRecord"
                   v-model="visitFormData.visitDuration" label="拜访时长" placeholder="请输入拜访时长">
          <template #right-icon>
                  <span class="row-name">
                    小时
                  </span>
          </template>
        </van-field>
        <!--联系电话-->
        <!--        <van-field input-align="right" v-model="visitFormData.customerUserPhone" label="联系电话"-->
        <!--                   placeholder="请输入联系电话"/>-->
        <!--随行人员-->
        <van-field input-align="right" v-model="visitFormData.visitEntourage" @change="buildVisitRecord"
                   label="随行人员" placeholder="请输入随行人员"/>
        <!--拜访记录-->
        <van-field input-align="right" v-model="visitFormData.visitGoal" rows="2" autosize label="拜访记录"
                   type="textarea" maxlength="140" placeholder="请输入拜访记录" show-word-limit/>
        <van-field :value.prop="visitFormData.fileList" class="noAfterBorder fileValueBox" input-align="right" name="fj"  label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :files="visitFormData.fileList" @success="uploadSuccess" moduleType="visit"
             @fileRemove="(removedFile)=>handleFileRemove(removedFile,'visitFormData','fileList')"></uploadFiles>
          </template>
        </van-field>
        <!--  <div class="m-l-32">
          <span class="font-28 cor-333333 m-r-20">上传附件</span>
         <van-uploader
              v-model="visitFormData.showFileList"
              :after-read="afterAddFile"
              @delete="handleDeleteFile"
              multiple
              :max-count="10"
          />
        </div> -->

        <div class="bottom-bar-placeholder">
          <div class="bottom-bar flex">
            <div class="btn-item flex-1 bg-FFDB43" @click="onSubmit">
              {{ '保存' }}
            </div>
            <div class="btn-item flex-1 bg-FF" @click="goBack">
              {{ '取消' }}
            </div>
          </div>
        </div>

        <!--        <div class="m-30">-->
        <!--          <van-row>-->
        <!--            <van-col :span="12">-->
        <!--              <van-button round block type="info" size="small" color="#FCE245" >保存</van-button>-->
        <!--            </van-col>-->
        <!--            <van-col :span="12">-->
        <!--              <van-button round block size="small" @click="goBack" native-type="button">取消</van-button>-->
        <!--            </van-col>-->
        <!--          </van-row>-->
        <!--        </div>-->
      </van-form>
    </div>
  </div>
</template>
<script>
import {Cell, Col, Notify, Row, Toast} from 'vant';
import {
  getCustomerVisitById,
  saveCustomerVisitAPI,
  selectCustomerByCompany,
  selectCustomerCompanyListAll,
  updateCustomerVisitAPI
} from '@/api/visit.js';
import {getDictDataByType} from '@/api/dict.js';
// import {upLoadFile} from '@/api/file.js';
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import mixin from '@/mixin/flow'
import * as ww from "@wecom/jssdk";
import axios from 'axios';


export default {
  components: {
    'van-row': Row,
    'van-col': Col,
    'van-cell': Cell,
    [Notify.Component.name]: Notify.Component,uploadFiles

  },
  mixins: [mixin,fileMixins],
  data() {
    return {
      isEdit: false,
      id: null,
      visitId: null,
      columns: ['见面', '电话', '邮件', '微信'],
      showPicker: false,
      createBy: null,
      date: null,
      text: '',
      valuePicker: '',
      loginUser: {},
      formData: {},
      isSubmitting: false, // 添加防重复点击状态变量
      // 显示定位选择框
      showLocationPicker: false,
      locationColumns: ['ceshi1', 'ceshi2'],
      visitFormData: {
        visitTime: '',
        visitDateTime: new Date(),
        visitGoal: '',
        fileList: [],
        showFileList: [],
        customerCompanyPlace: '',
        customerCompanyName: '',
        nowLocation: '',
      },
      customerUserPhoneDisabled: true,
      companyId: '',
      companyQueryParams: {},
      customerUserList: [],
      maxSize: 10, // 添加文件大小限制，单位MB
      isUploading: false, // 添加上传状态
      userShow: false,// 拜访人员显隐
      pickerShow: false,// 拜访方式
      // 数据字典
      visitDictData: [],
      dateTimeShow: false,// 拜访日期显示隐藏
      pageType: 'add',
      // 所属客户
      companyName: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },

    };
  },
  created() {
    this.loginUser = JSON.parse(sessionStorage.getItem('userInfo'));
    if (this.$route.query.customerCompanyName) {
      this.visitFormData.customerCompanyName = this.$route.query.customerCompanyName
      this.companyId = this.$route.query.companyId
      this.visitFormData.customerCompanyId = this.$route.query.companyId
    }
    this.visitId = this.$route.query.id
    if (this.visitId) {
      this.isEdit = true;
      this.getVisitFormData();
    } else {
    }
    //
    this.getVisitDictDataByType('customer_visit_type');
    this.sskhBlur();
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      //   this.$router.push({path: '/visitList'})
    },
    getLocal() {
      let that = this;
      ww.getLocation({
        type: 'wgs84',
        success: (res) => {
          console.log("res", res)
          let latitude = res.latitude;
          let longitude = res.longitude;
          that.getLocationMessaage(latitude, longitude)
        },
        fail: (err) => {
          alert('获取定位异常' + JSON.parse(err))
          console.log("err", err)
        }
      })
    },

    async getLocationMessaage(lat, lng) {
      let url = '/qqmap'
      // console.log(url)
      // this.visitFormData.nowLocation = url
      try {
        // 使用代理服务器地址代替腾讯地图 API 的直接地址
        const response = await axios.get(url, {
          params: {
            location: lat + ',' + lng,
            key: 'MVYBZ-PSYKI-I4ZGV-U6KRT-IC6ZH-HJFMQ'
          }
        });

        // 处理响应数据
        if (response.data.status === 0) {
          let addressData = response.data.result;
          this.visitFormData.nowLocation = addressData.formatted_addresses.standard_address + ',' + addressData.formatted_addresses.recommend;
          // alert(JSON.stringify(response.data.result));
        } else {
          alert("获取位置错误，请重试");
          console.log("获取位置错误：" + response.data.message);
        }
      } catch (error) {
        alert("获取位置异常，请重试");
        console.error('获取位置异常，请重试:', error);
      }
    },
    onLocationConfirm(value) {
      this.visitFormData.nowLocation = value;
      this.showLocationPicker = false;
    },
    /**
     * 废弃方法
     */
    onConfirm(date) {
      this.showCalendar = false;
      this.date = date;

      this.valuePicker = date;
      this.showPicker = false;
    },

    /**
     *  所属客户查询
     */
    sskhBlur() {
      selectCustomerCompanyListAll({
        pageSize: 50,
        pageNum: 1,
        companyName: this.companyName.filterText,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            return Toast.fail("未检索到客户名称");
          }
          this.companyName.data = res.data;
          this.companyName.filteredData = this.companyName.data;
          this.companyName.show = false;
        } else {
          Toast.fail(res.message);
        }
      })
    },
    pickerSearchCompany() {
      selectCustomerCompanyListAll({
        pageSize: 50,
        pageNum: 1,
        companyName: this.companyName.filterText,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            return Toast.fail("未检索到客户名称");
          }
          this.companyName.data = res.data;
          this.companyName.filteredData = this.companyName.data;
        } else {
          Toast.fail(res.message);
        }
      })
    },
    // 清空所属客户则清空所有内容
    clearCompany() {
      this.companyName.show = false;
      this.formData = {};
      // this.visitFormData.visitDateTime = new Date();
      this.visitFormData.visitGoal = '';
      this.visitFormData.fileList = [];
      this.visitFormData.showFileList = [];
      this.customerUserPhoneDisabled = true;
    },
    /**
     * 选择所属客户触发
     */
    sskhConfirm() {
      this.clearCompany(); // 清空所有内容

      const item = this.$refs['companyName'].getValues()[0]
      console.log("item", item)
      const data = item;
      this.companyName.show = false;
      this.$set(this.visitFormData, 'customerCompanyName', item['companyName'])
      this.$set(this.visitFormData, 'customerCompanyPlace', item['companyPlace'])
      // this.formData.companyName = data.companyName;
      this.companyId = data.id;
      this.companyQueryParams.companyId = data.id;
      this.visitFormData.customerCompanyId = data.id;
      this.getCustomerUser(data.id); // 查询联系人
    },
    /**
     *  查询联系人
     */
    getCustomerUser(companyId) {
      if (!companyId) {
        // Notify({ type: 'warning', message: '请选择所属客户' });
        Toast.fail('请选择所属客户');
        return
      }
      companyId = companyId * 1
      selectCustomerByCompany(companyId).then(res => {
        if (res.code == '200') {
          if (res.rows.length == 0) {
            // Notify({ type: 'warning', message: '该客户下暂无联系人' });
            Toast.fail('该客户下暂无联系人');
            return
          }
          this.customerUserList = res.rows;
          this.userShow = true
        }
      })
    },
    /**
     *  日期格式化
     * @param type
     * @param value
     * @returns {*|string}
     */
    dateformatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      }
      if (type === 'month') {
        return `${value}月`
      }
      if (type === 'day') {
        return `${value}日`
      }
      if (type === 'hour') {
        return `${value}时`
      }
      if (type === 'minute') {
        return `${value}分`
      }
      return value
    },

    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    /**
     *  拜访日期确认
     */
    dateTimeConfirm(data) {
      this.visitFormData.visitTime = this.formatDate(data, 'yyyy-MM-dd hh:mm');
      this.dateTimeShow = false;
      this.buildVisitRecord();
    },
    /**
     *  构建拜访记录
     */
    buildVisitRecord() {
      if (this.visitFormData.visitTime && this.visitFormData.visitTypeName) {
        this.visitFormData.visitGoal = `${this.visitFormData.visitTime},${this.loginUser.nickName}以${this.visitFormData.visitTypeName}的方式拜访了${this.visitFormData.customerUserName}。${this.visitFormData.visitDuration ? `拜访时长为${this.visitFormData.visitDuration}小时。` : ''}${this.visitFormData.visitEntourage ? `随行人员有：${this.visitFormData.visitEntourage}。` : ''}`
      }
    },
    /**
     *  拜访方式确认
     */
    pickerConfirm(data) {
      this.visitFormData.visitTypeName = data.dictLabel;
      this.visitFormData.visitType = data.dictValue;
      this.pickerShow = false;
      this.buildVisitRecord();
    },
    /**
     *  查询数据字典
     */
    getVisitDictDataByType(type) {
      getDictDataByType(type).then(res => {
        if (res.code == '200') {
          this.visitDictData = res.data;
        }
      })
    },
    /**
     *  拜访人确认
     */
    userConfirm(data) {
      this.visitFormData.customerUserId = data.id;
      this.visitFormData.customerUserName = data.userName;
      this.visitFormData.customerUserPhone = data.userTelephone;
      this.userShow = false;
      this.buildVisitRecord();
    },
    /**
     * 表单验证
     */
    validateForm() {
      // 必填项校验

      if (!this.visitFormData.visitTime) {
        Toast.fail('请选择拜访日期');
        return false;
      }

      if (!this.visitFormData.visitTypeName) {
        Toast.fail('请选择拜访方式');
        return false;
      }

      if (!this.visitFormData.customerUserName) {
        Toast.fail('请选择拜访人');
        return false;
      }

      return true;
    },
    // ... existing code ...
    onSubmit(values) {
      // 防重复点击
      if (this.isSubmitting) {
        Toast.fail('正在提交中，请勿重复点击');
        return;
      }
      // 检查是否正在上传文件
      if (this.isUploading) {
        Toast.fail('文件正在上传中，请稍后保存');
        return;
      }
      // 前端必填项校验
      if (!this.validateForm()) {
        return;
      }

      // 设置提交状态
      this.isSubmitting = true;
      // 添加即时反馈
      Toast.loading({
        message: '保存中...',
        forbidClick: true,
        duration: 0
      });

      // 清理和格式化数据，特别是iOS设备上的文件数据
      const submitData = this.formatSubmitData(this.visitFormData);
      console.log("提交数据：", submitData);
      if (!this.isEdit) {
        console.log("新增保存");
        saveCustomerVisitAPI(submitData).then(res => {
          // alert(res.code) // 移除alert，使用Toast
          if (res.code == 200) {
            Toast.success('保存成功');
            // 返回上一级页面的代码
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            // 错误时重置提交状态
            this.isSubmitting = false;
            Toast.clear();
            Toast.fail(res.message || '保存失败');
          }
        }).catch(err => {
          this.isSubmitting = false;
          Toast.clear();
          Toast.fail('保存失败，请重试');
        })
      } else {
        console.log("编辑保存");
        try {
          updateCustomerVisitAPI(submitData).then(res => {
            // alert(res.code) // 移除alert，使用Toast
            if (res.code == 200) {
              Toast.success('保存成功');
              // 返回上一级页面的代码
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            } else {
              // 错误时重置提交状态
              this.isSubmitting = false;
              Toast.clear();
              Toast.fail(res.message || '保存失败');
            }
          })
        } catch (error) {
          // 错误时重置提交状态
          this.isSubmitting = false;
          Toast.clear();
          Toast.fail('保存失败');
        }
      }
    },

    /**
     * 格式化提交数据，清理iOS设备上的特殊数据格式
     */
    formatSubmitData(formData) {
      // 深拷贝数据，避免修改原始数据
      const data = JSON.parse(JSON.stringify(formData));
      console.log('formData1111111111', data.fileList);
      // 清理文件列表数据，只保留必要的字段
      if (data.fileList && Array.isArray(data.fileList)) {
        data.fileList = data.fileList.map(file => ({
          id: file.id,
          fileName: file.name,
          filePath: file.fileUrl,
          fileSize: file.fileSize,
          // createByName: file.createByName
          // 移除其他可能包含特殊iOS属性的字段
        }));
      }

      // 清理showFileList，这个字段不应该发送到后端
      delete data.showFileList;

      // 清理可能包含特殊iOS属性的字段
      delete data.visitDateTime; // 这个字段是Date对象，可能序列化有问题

      // 确保所有字符串字段都是基本类型
      const stringFields = [
        'customerCompanyName', 'customerCompanyPlace', 'visitTime',
        'visitTypeName', 'customerUserName', 'visitGoal', 'visitEntourage'
      ];

      stringFields.forEach(field => {
        if (data[field] && typeof data[field] !== 'string') {
          data[field] = String(data[field]);
        }
      });

      // 确保数字字段是数字类型
      const numberFields = ['customerCompanyId', 'customerUserId', 'visitDuration'];
      numberFields.forEach(field => {
        if (data[field] !== undefined && data[field] !== null) {
          data[field] = Number(data[field]);
        }
      });

      return data;
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    /**
     *  获取拜访数据
     */
    getVisitFormData() {
      getCustomerVisitById(this.visitId).then(res => {
        if (res.code == 200) {
          this.visitFormData = res.data;
          this.visitFormData.visitDateTime = new Date(this.visitFormData.visitTime);

          this.visitDictData.forEach(item => {
            if (item.dictValue == this.visitFormData.visitType) {
              this.visitFormData.visitTypeName = item.dictLabel;
            }
          })
          // 添加附件回显逻辑
          if (res.data.fileList && res.data.fileList.length > 0) {
            // 将已有的附件数据转换为van-uploader需要的格式
            this.visitFormData.showFileList = res.data.fileList.map(file => ({
              url: file.fileURL, // 获取完整的文件URL
              name: file.fileName,
              status: 'done', // 标记为已完成上传
              message: '上传成功',
              fileId: file.id // 保留文件ID用于后续操作
            }));

            console.log('回显附件列表:', this.visitFormData.showFileList);
          } else {
            this.visitFormData.showFileList = [];
          }
          console.log(this.visitFormData.showFileList, this.$store.state.settings.image_base_url, 'this.visitFormData.showFileList');
        } else {
          Toast.fail(res.message);
        }
      })
    },
    /**
     * 获取文件完整URL
     */
    getFileUrl(filePath) {
      if (!filePath) return '';

      // 如果已经是完整URL，直接返回
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        return filePath;
      }

      // 使用Vuex中的基础URL配置
      const baseUrl = this.$store.state.settings.image_base_url || '';

      // 确保路径格式正确
      let formattedPath = filePath;
      if (filePath.startsWith('/')) {
        formattedPath = filePath.substring(1);
      }

      return baseUrl + formattedPath;
    },
    /**
     * 处理文件删除
     */
    handleDeleteFile(file, detail) {
      console.log('删除文件:', file, '详情:', detail);

      // 由于van-uploader会自动删除文件，我们需要在删除后同步数据
      // 这里我们使用setTimeout确保van-uploader已经完成删除操作
      this.$nextTick(() => {
        // 如果文件已经上传到服务器，还需要从fileList中删除
        if (file.fileId) {
          const serverFileIndex = this.visitFormData.fileList.findIndex(f => f.id === file.fileId);
          if (serverFileIndex !== -1) {
            this.visitFormData.fileList.splice(serverFileIndex, 1);
          }
        }

        Toast.success('删除成功');

        // 强制更新视图
        this.$forceUpdate();
      });
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      console.log(fileList)
      this.visitFormData.fileList = fileList
    },
    // // 上传附件到后台
    // afterAddFile(file) {
    //   // 处理多文件上传的情况
    //   if (Array.isArray(file)) {
    //     file.forEach(item => this.handleSingleFile(item));
    //     return;
    //   }
    //   this.handleSingleFile(file);
    // },

    // // 处理单个文件上传
    // handleSingleFile(file) {
    //   // 检查文件大小
    //   if (file.size / 1024 / 1024 > this.maxSize) {
    //     Toast.fail(`单个附件最大不超过 ${this.maxSize}MB`);
    //     return false;
    //   }

    //   // 设置上传状态
    //   this.isUploading = true;
    //   Toast.loading({
    //     message: '上传中...',
    //     forbidClick: true,
    //     duration: 0
    //   });

    //   let FormDatas = new FormData();
    //   FormDatas.append('file', file.file);
    //   FormDatas.append('moduleType', 'visit');

    //   upLoadFile(FormDatas).then(res => {
    //     // 重置上传状态
    //     this.isUploading = false;
    //     Toast.clear();

    //     if (res.data && res.code === 200) {
    //       res.data.fileName = file.file.name
    //       res.data.createByName = this.loginUser.nickName

    //       // 添加到文件列表
    //       this.visitFormData.fileList.push(res.data);

    //       // 更新显示列表中的对应文件状态
    //       // 使用文件名作为唯一标识来查找对应的文件
    //       const fileIndex = this.visitFormData.showFileList.findIndex(f =>
    //           f.file && f.file.name === file.file.name
    //       );

    //       if (fileIndex !== -1) {
    //         // 使用 Vue.set 或 this.$set 确保响应式更新
    //         this.$set(this.visitFormData.showFileList, fileIndex, {
    //           ...this.visitFormData.showFileList[fileIndex],
    //           status: 'done',
    //           message: '上传成功',
    //           fileId: res.data.id,
    //           url: this.getFileUrl(res.data.filePath) // 添加文件URL用于显示
    //         });

    //         // 强制触发视图更新
    //         this.$forceUpdate();
    //       }

    //       Toast.success('上传成功');
    //       return true;
    //     } else {
    //       Toast.fail('上传失败');
    //       return false;
    //     }
    //   }).catch(err => {
    //     // 重置上传状态
    //     this.isUploading = false;
    //     Toast.clear();
    //     console.log("上传失败", err)
    //     Toast.fail("上传失败")
    //     return false;
    //   });
    // },
  }

};
</script>
<style lang="scss" scoped>
.noAfterBorder{
  &::after{
    border-bottom: 0px solid #f5f5f5;
  }
}
.row-info {
  margin-bottom: 16px;
  margin-top: 20px;
  background-color: rgb(253, 253, 253)
}

.row-name {
  font-size: 30px;
  color: #969799;
}

.row-value {
  text-align: left;
  font-size: 30px;
  color: #000000;
}

.bottom-bar-placeholder {
  height: 140px; /* 增加预留空间，适配iOS安全区域 */
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  /* iOS安全区域适配 */
  padding-bottom: env(safe-area-inset-bottom, 20px);
  padding-bottom: constant(safe-area-inset-bottom, 20px);
}

/* 添加媒体查询适配不同屏幕 */
@media (max-height: 700px) {
  .bottom-bar-placeholder {
    height: 120px;
  }
}

@media (max-height: 600px) {
  .bottom-bar-placeholder {
    height: 100px;
  }
}

/* 添加自定义Toast样式，确保在iOS上可见 */
.van-toast {
  z-index: 9999 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  -webkit-transform: translate(-50%, -50%) !important;
  background-color: rgba(0, 0, 0, 0.8) !important;
  border-radius: 8px !important;
  padding: 12px 20px !important;
  color: white !important;
  font-size: 14px !important;
  max-width: 80% !important;
  text-align: center !important;
}

/* iOS安全区域适配 */
@supports (padding: max(0px)) {
  .van-toast {
    padding-bottom: max(12px, env(safe-area-inset-bottom)) !important;
  }
}
</style>
